import { render } from "./EducationalTutorials.vue?vue&type=template&id=033df0a8&scoped=true"
import script from "./EducationalTutorials.vue?vue&type=script&lang=js"
export * from "./EducationalTutorials.vue?vue&type=script&lang=js"

import "./EducationalTutorials.vue?vue&type=style&index=0&id=033df0a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033df0a8"]])

export default __exports__